import { Box } from '@mantine/core';
import { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'src/components/Icon';
import { links } from 'src/router/routes';

import styles from './styles.module.css';

export const AddBox: FC = memo(() => {
  return (
    <Box className={styles.box}>
      <Link className={styles.link} to={links.interactionDictionaryNew}>
        <div className={styles.content}>
          <Icon name="add" className={styles.addIcon} />
          <span className={styles.addText}>Add New</span>
        </div>
      </Link>
    </Box>
  );
});
